export interface EmailParts {
  greeting: string;
  message: string;
  shareUrl: string;
  giftAidMessage?: string;
  thanks: string;
}

export function generateEmailBody({
  greeting,
  message,
  shareUrl,
  giftAidMessage,
  thanks,
}: EmailParts) {
  const BR = '\n\n';
  const giftAid = giftAidMessage ? `${giftAidMessage}${BR}` : '';
  return `${greeting}, ${BR}${message} ${shareUrl}${BR}${giftAid}${thanks}`;
}
